import React from "react";
import { motion } from "framer-motion";
import { STEPS } from "@/data/content";
import { Reveal, Overline } from "./Reveal";

export const HowToUse = () => {
  return (
    <section id="how" data-testid="how-section" className="relative py-24 md:py-32 radial-emerald noise">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <Reveal>
              <Overline index="03">How To Use</Overline>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-serif text-3xl md:text-5xl tracking-tight text-white leading-[1.1]">
                Four steps. One simple daily ritual.
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.num}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="relative glass rounded-2xl p-8 hover:border-gold/30 transition-colors duration-300"
              data-testid={`step-${i}`}
            >
              <span className="font-serif text-6xl text-gold/25 leading-none">{s.num}</span>
              <div className="mt-6 mb-4 h-11 w-11 rounded-xl border border-gold/25 grid place-items-center">
                <s.icon className="h-5 w-5 text-gold" strokeWidth={1.5} />
              </div>
              <h3 className="font-serif text-2xl text-white mb-1">{s.title}</h3>
              <p className="text-vmuted text-[15px] leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
